import React, { useMemo } from 'react';
import { useState, useEffect, useContext } from 'react';
import Loader from 'react-loader-spinner';
import { Card, CardHeader, CardBody, Label, FormGroup, Input, Container, Row, Col } from 'reactstrap';
import { putpost, getAPI, masterServiceBaseUrl } from 'services/http';
import Select from 'react-select';
import { useHistory, useParams } from 'react-router-dom';
import IsCoreMaster from 'views/pages/manage/common/commonComponents/coreMaster';
import { failureToast, successToast } from '../../../common/utils/methods/toasterFunctions/function';
import { PermisionDenied } from '../../../common/commonComponents';
import CustomButton from 'components/CustomButton';
import { endpoint, regex, pages } from '../../../common/constant';
import { fetchAllPostPromisedData, fetchDetails, updateRequest } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { PermissionContext, RolePermissions } from '../../../../../../appContext';
import { DisplayViewData, getAuditDetails } from './common';
import { basicDetail, BU_TYPE_FRANCHISE_ACCESS, franchiseTypeDropdown, menuItems, URL_REGEX } from './constant';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { statusDropdown } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import moment from 'moment';


const BusinessUnit_2 = props => {
  let history = useHistory();
  const {
    nextStep = () => { },
    isNew = true,
    formId,
    isPrevious,
    data,
    action,
    isCopied,
    fetchBusinessAreaDetails,
    // userPermissions,
    selectedTabValue,
    setSelectedTabValue,
    setBuId,
    isEdit,
    setIsEdit,
    setDropdowns,
    setStatus = () => { },
    taxMapping,
    value,
    setValue,
  } = props;

  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(permissions, pages['businessAreaBasicDetails']['id']);



  const [apiloader, setApiLoader] = useState(false);
  const [currency, setCurrency] = useState([]);
  const [group, setgroupCode] = useState([]);
  const [region, setRegion] = useState([]);
  const [businessUnitType, setbusinessUnitType] = useState([]);
  const [companyCode, setcompanyCode] = useState([]);
  const [showCompanyCode, setShowCompanyCode] = useState([]);
  const [campusInstitution, setcampusInstitution] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [randomKey, setRandomKey] = useState('randomKey');
  const [isUpdated, setIsUpdated] = useState(false);
  const [stateData, setStateData] = useState([])
  const [prevData, setPrevData] = useState({})
  const [testTypeIds, setTestTypeIds] = useState({})

  const selectAllOption = { label: 'Select All', value: Date.now() };


  const [arrayState, setArrayState] = useState({
    regionArray: [],
    businessUnitTypeArray: [],
    academicCareerArray: [],
    academicGroupArray: [],
    academicClassArray: [],
    studyCenterArray: []
  });



  const insertData = data => {
    //////console.log("inside the insert data section",data)
    resetValues();
    let x = [];
    data &&
      data['regionId'] &&
      data['regionId'].map(data => {
        x.push(getSelectedObj(data, region));
        // setValue({
        //   ...value,
        //   region: x,
        // });
      });

    let y = [];
    data &&
      data['businessUnitTypeId'] &&
      data['businessUnitTypeId'].map(data => {
        y.push(getSelectedObj(data, businessUnitType));
        // setValue({
        //   ...value,
        //   businessUnitType: y,
        // });
      });
 let z = [];
    data &&
      data['testTypeIds'] &&
      data['testTypeIds'].map(data => {
        z.push(getSelectedObj(data, testTypeIds));
      });
    setValue({
      ...value,
      businessUnitType: y,
      region: x,
      testTypeIds: z,
      businessAreaKey: data && data['businessAreaKey'],
      companyCode: getSelectedObj(data && data['companyCodeId'], companyCode),
      groupCode: getSelectedObj(data && data['groupCodeId'], group),
      campusInstitution: getSelectedObj(data && data['campusInstitutionId'], campusInstitution),
      // status: data && data['status'],
      currency: getSelectedObj(data && data['currencyId'], currency),
      franchiseType: getSelectedObj(data && data['franchiseType'], franchiseTypeDropdown),
      jurisdiction: data && data['jurisdiction'],
      serviceTaxRegistration: data && data['serviceTaxRegistration'],
      gstInNumber: data && data['gstInNumber'],
      cinllpNumber: data && data['cinllpNumber'],
      tid: data && data['tid'],
      referenceId: data && data['referenceId'],
      branchDisplayName: data && data['businessAreaDesc'],
      businessAreaDesc: data && data['businessAreaDesc'],
      businessAreaDispValue: data && data['businessAreaDispValue'],
      acadOrg: data && data['acadOrg'],

      sapPlantId: data?.['sapPlantId'] ?? '',
      sapBusinessArea: data && data['sapBusinessArea'],
      sapDescription: data?.['sapDescription'] ?? '',
      businessPlaceCode: data?.['businessPlaceCode'] ?? '',
      defermentBusinessArea: data?.['defermentBusinessArea'] ?? '',
      // gstInNumber: data?.['gstInNumber'] ?? '',
      stateCode: data?.stateCode ? stateData.find(i => i.stateCode === +(data?.stateCode)) : '',
      buUrlName: data?.buUrlName ?? '',
      buUrl: data?.buUrl ?? '',
      updatedOn: data?.updatedOn,
      updatedBy: data?.updatedBy,
      effectiveDate: data?.effectiveDate,
      franchiseBusinessName: data?.franchiseBusinessName,
      franchiseRegisteredAddress: data?.franchiseRegisteredAddress,
      franchiseSubType: data?.franchiseSubType,
      status: data && { sfWb: data?.statusSalesforceWebsite, phx: data?.status }
    });
    setStatus(data && { sfWb: data?.statusSalesforceWebsite, phx: data?.status })
    setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
  };

  const getSelectedObj = (id, arr) => {
    return arr.filter(item => {
      return item.value === id;
    })[0];
  };

  useEffect(() => {
    ////console.log("is Copied",isCopied)

    if (action === 'view' || action === 'edit') {
      //console.log('inside the edit section')
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

    if (
      data &&
      !isPrevious &&
      isCopied &&
      group.length > 0 &&
      companyCode.length > 0 &&
      region.length > 0 &&
      businessUnitType.length > 0 &&
      currency.length > 0 &&
      campusInstitution.length > 0 &&
      // academicCareerData.length > 0 &&
      // academicGroupData.length > 0 &&
      // academicClassData.length > 0 &&
      stateData?.length > 0 &&
      testTypeIds.length > 0
    ) {
      insertData(data);
    }
  }, [data, isCopied, isNew, group, companyCode, region, businessUnitType, currency, franchiseTypeDropdown, campusInstitution, stateData, testTypeIds]);

  useEffect(() => {
    getBuDetailByBuId()
  }, [isPrevious, formId, group, companyCode, region, businessUnitType, currency, campusInstitution, stateData, testTypeIds]);
  const getBuDetailByBuId = (values) => {
    if (
      isPrevious &&
      formId &&
      group.length > 0 &&
      companyCode.length > 0 &&
      region.length > 0 &&
      businessUnitType.length > 0 &&
      currency.length > 0 &&
      campusInstitution.length > 0 &&
      // academicCareerData.length > 0 &&
      // academicGroupData.length > 0 &&
      // academicClassData.length > 0 &&
      stateData?.length > 0 &&
      testTypeIds.length > 0
    ) {
      setApiLoader(true);
      getAPI(
        `${masterServiceBaseUrl}/businessArea/getBusinessAreaV2/${formId}`,
        data => {
          ////console.log(data.data)
          insertData(data.data);
          setApiLoader(false);
        },
        data => {
          setApiLoader(false);
          failureToast(data['message']);
        }
      );
    }
  }
  const fetchData = (url, stateMethod, name) => {
    setApiLoader(true);
    getAPI(
      url,
      data => {
        let list = [];
        //this is for dropdown fields only
        const keyName = `${name}DispValue`;
        const key = `${name}Desc`;
        const key1 = `${name}Key`;
        list = data.data.map(data => {
          return {
            value: data.id,
            label: data[keyName],
            desc: data[key],
            key: data[key1],
          };
        });
        stateMethod(list);
        setApiLoader(false);
      },
      data => {
        setApiLoader(false);
        failureToast(data['message']);
      }
    );
  };

  const resetValues = () => {
    setValue({
      businessAreaKey: '',
      businessAreaDispValue: '',
      businessAreaDesc: '',
      region: [],
      currency: '',
      groupCode: '',
      companyCode: '',
      campusInstitution: '',
      jurisdiction: '',
      serviceTaxRegistration: '',
      gstInNumber: '',
      stateCode: '',
      cinllpNumber: '',
      tid: '',
      referenceId: '',
      branchDisplayName: '',
      businessUnitType: [],
      status: { label: 'Active', value: 'ACTIVE' },
      updatedOn: '',
      effectiveDate: '',
      acadOrg: '',
      academicCareer: [],
      academicGroup: [],
      academicClass: [],
      sapPlantId: '',
      sapBusinessArea: '',
      sapDescription: '',
      businessPlaceCode: '',
      defermentBusinessArea: '',
      buUrl: '',
      buUrlName: '',
      franchiseType: '',
      franchiseBusinessName: '',
      franchiseRegisteredAddress: '',
      franchiseSubType: '',
      testTypeIds: []
    });
    setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
  };

  const getCompanyCode = value => {
    try {
      getAPI(
        masterServiceBaseUrl + `/companyCode/getCompanyCodeByGroup/${value}`,
        data => {
          let tempCompanyCode = [];
          data &&
            data.data.map(item => {
              tempCompanyCode.push({
                value: item.id,
                label: item.companyCodeDispValue,
                key: item.companyCodeKey,
                desc: item.companyCodeDesc,
              });
            });
          setValue(preState => ({
            ...preState,
            companyCode: '',
          }));
          setShowCompanyCode(tempCompanyCode);
        },
        data => {
          setValue(preState => ({
            ...preState,
            companyCode: '',
          }));
          setShowCompanyCode([]);
          failureToast(data['message']);
        }
      );
    } catch (e) {
      //////console.log('Error', e);
    }
  };
  // //////console.log('formId', formId);
  // //////console.log('ValuesObject___', value);

  const multiSelectArrayMapping = () => {
    let x = arrayState && arrayState.regionArray;

    value &&
      value.region &&
      value.region.map(data => {
        x.push(data.value);
        setArrayState({
          ...arrayState,
          regionArray: x,
        });
      });
    let y = arrayState && arrayState.businessUnitTypeArray;
    value &&
      value.businessUnitType &&
      value.businessUnitType.map(data => {
        y.push(data.value);
        setArrayState({
          ...arrayState,
          businessUnitTypeArray: y,
        });
      });
    let z = arrayState && arrayState.studyCenterArray;

    value &&
      value.testTypeIds &&
      value.testTypeIds.map(data => {
        z.push(data.value);
        setArrayState({
          ...arrayState,
          studyCenterArray: z,
        });
      });
  };

  // //////console.log('arrayState__', arrayState);

  const SaveButton = async () => {
    
    //console.log('Values is here ',value)
    setApiLoader(true);

    setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
    // //////console.log('arrayState__', arrayState);

    if (value.businessAreaKey === '') {
      failureToast('Please Enter Business Area Key');
      setApiLoader(false);
      return;
    } else if (value.businessAreaKey && value.businessAreaKey.length < 5) {
      failureToast('Business Area Key must have atleast 5 characters');
      setApiLoader(false);
      return;
    } else if (!value.groupCode || value.groupCode === '') {
      failureToast('Please Select Group Code');
      setApiLoader(false);
      return;
    } else if (value.region === null || value.region == '') {
      failureToast('Please Select Region');
      setApiLoader(false);
      return;
    } else if (!value.businessUnitType || value.businessUnitType == '') {
      failureToast('Please Select Business Area Type');
      setApiLoader(false);
      return;
    } else if (!value.companyCode || value.companyCode === '') {
      failureToast('Please Select Company Code');
      setApiLoader(false);
      return;
    } else if (!value.campusInstitution || value.campusInstitution === '') {
      failureToast('Please Select Campus Institution');
      setApiLoader(false);
      return;
    } else if (!value.currency || value.currency === '') {
      failureToast('Please Select Currency');
      setApiLoader(false);
      return;
    } else if (value.stateCode === null || value.stateCode === '' || !value.stateCode?.value) {
      failureToast('Please Select State code');
      setApiLoader(false);
      return
    } else if (!value.businessAreaDispValue || value.businessAreaDispValue === '') {
      failureToast('Please Enter Display Value');
      setApiLoader(false);
      return;
    }
    // else if (!value.businessAreaDesc || value.businessAreaDesc === '') {
    //   failureToast('Please Enter Description');
    //   setApiLoader(false);
    //   return;
    // } 
    else if (!value.acadOrg || value.acadOrg === '') {
      failureToast('Please Enter Academic Organisation');
      setApiLoader(false);
      return;
    }
    else if (!value.effectiveDate || value.effectiveDate == '') {
      failureToast('Please Select Effective Date');
      setApiLoader(false);
      return;
    }

    else if (value.gstInNumber && !value.gstInNumber.startsWith(value.stateCode.gstCode)) {
      failureToast('Please Enter Valid GSTIN number');
      setApiLoader(false);
      return
    } else if (value.gstInNumber && value.gstInNumber?.length < 15) {
      failureToast('Please Enter Valid GSTIN number');
      setApiLoader(false);
      return
    }
    else if (value?.buUrl && !URL_REGEX.test(value.buUrl)) {
      failureToast('Please Enter Valid BU URL');
      setApiLoader(false);
      return;
    }
    // else if (!value.testTypeIds|| value.testTypeIds == '' ||! value.testTypeIds.length) {
    //   failureToast('Please Select Study Center');
    //   setApiLoader(false);
    //   return;
    // }
    else if (value?.businessUnitType.some(item => BU_TYPE_FRANCHISE_ACCESS.includes((item.label).toLowerCase()))) {
      if (!value?.franchiseType) {
        failureToast('Please Enter Franchise Type');
        setApiLoader(false);
        return;
      }
      else if (!value?.franchiseBusinessName) {
        failureToast('Please Enter Franchise Business Name');
        setApiLoader(false);
        return;
      }
      else if (!value?.franchiseRegisteredAddress) {
        failureToast('Please Enter Franchise Registered Address');
        setApiLoader(false);
        return;
      }
      else if (!value?.franchiseSubType) {
        failureToast('Please Enter Franchise Subtype');
        setApiLoader(false);
        return;
      }

    }

    // if (action === 'new') {

    let canContinue = true;
    // if (!isNew || isPrevious) {
    //   canContinue = await confirm();
    // }
    if (!canContinue) {
      setApiLoader(false);
      return
    }

    // }
    multiSelectArrayMapping();

    let obj = {
      businessAreaKey: value?.businessAreaKey,
      regionId: arrayState?.regionArray,
      currencyId: value?.currency?.value,
      groupCodeId: value?.groupCode?.value,
      companyCodeId: value?.companyCode?.value,
      campusInstitutionId: value?.campusInstitution?.value,
      jurisdiction: value?.jurisdiction,
      serviceTaxRegistration: value?.serviceTaxRegistration,
      gstInNumber: value?.gstInNumber,
      cinllpNumber: value?.cinllpNumber,
      tid: value?.tid,
      referenceId: value?.referenceId,
      branchDisplayName: value?.businessAreaDesc,
      businessUnitTypeId: arrayState?.businessUnitTypeArray,
      businessAreaDispValue: value?.businessAreaDispValue,
      businessAreaDesc: value?.businessAreaDesc,
      status: value?.status?.phx,
      acadOrg: value?.acadOrg,
      statusSalesforceWebsite: value?.status?.sfWb,
      // academicCareerId: arrayState.academicCareerArray,
      // academicStreamId: arrayState.academicGroupArray,
      // classMasterId: arrayState.academicClassArray,
      // sapPlantId: value.sapPlantId,
      // sapBusinessArea: value.sapBusinessArea,
      // sapDescription: value.sapDescription,
      // businessPlaceCode: value.businessPlaceCode,
      // defermentBusinessArea: value.defermentBusinessArea,
      stateCode: value.stateCode?.value,
      buUrlName: value?.buUrlName,
      buUrl: value?.buUrl,
      effectiveDate: value?.effectiveDate,
      franchiseType: value?.franchiseType?.value,
      franchiseBusinessName: value?.franchiseBusinessName,
      franchiseRegisteredAddress: value?.franchiseRegisteredAddress,
      franchiseSubType: value?.franchiseSubType,
      testTypeIds: arrayState?.studyCenterArray
    };

    if (action != 'view' && action != 'edit') {
      props.setGroupCode(value.groupCode.value);
      props.setCompanyCode(value.companyCode.value);
    }

    let firstFormData = {
      businessUnit: null,
      companyCode: value.companyCode.value,
      companyCodeDispValue: value.companyCode.label,
      groupCode: value.groupCode.value,
      groupCodeKey: value.groupCode.key,
      groupCodeDesc: value.groupCode.desc,
      companyCodeKey: value.companyCode.key,
      businessUnitType: value.businessUnitType,
      businessKey: value.businessAreaKey,
      businessDesc: value.businessAreaDesc,
      companyCodeDesc: value.companyCode.desc,
      franchiseType: value?.franchiseType?.value,
      franchiseBusinessName: value?.franchiseBusinessName,
      franchiseRegisteredAddress: value?.franchiseRegisteredAddress,
      franchiseSubType: value?.franchiseSubType
    };

    if (isNew && !isPrevious) {

      putpost(
        // masterServiceBaseUrl + '/businessArea/createBusinessArea',
        endpoint.businessArea.createBU, //changed to buV2 endpoint
        data => {
          const req = taxMapping&&taxMapping.map((rowForm)=>(
            {
            businessAreaId: data['data']['id'],
            effectiveDate: moment(new Date()).format('YYYY-MM-DD'),
            taxCodePercent: rowForm?.taxCodePercent,
            taxCodeType: rowForm?.taxCodeType,
            taxType: rowForm?.taxType,
            codeId: rowForm?.codeId
          }))
          let url = endpoint.taxMapping.create;
          taxMapping && fetchAllPostPromisedData(url, req.map((row) => updateRequest(row)));
          // successToast(data['message']);
          props.setBusinessAreaId(data['data']['id']);
          setBuId(data['data']['id']);
          firstFormData['businessUnit'] = data['data']['id'];
          props.saveStepsCompleted(1);
          setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
          setApiLoader(false);
          //have commented this as need some more info from here
          // nextStep(data['data']['id']);

          //The Next line is for whole flow of bussiness are but for prod we are rolling out oly first page thats why commenting this
          //nextStep(firstFormData);
          //the next line have to be removed after 1st prod deployment
          successToast("Business Area information has been recorded");
          setSelectedTabValue(menuItems?.[1]);
          // history.push("/admin/businessUnit")
          //for first prod deployment
          setRandomKey(new Date().getMilliseconds());
        },
        data => {
          setApiLoader(false);
          setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
          failureToast(data['message']);
        },
        obj,
        'post'
      );
    }

    if (!isNew || isPrevious) {
      putpost(
        masterServiceBaseUrl + '/businessArea/updateBusinessArea/' + formId,
        data => {
          successToast(data['message']);
          fetchBusinessAreaDetails()
          // firstFormData['businessUnit']  = data['data']['id']
          // updateAllStepData(obj,'firstForm')
          setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
          // fetchBusinessAreaData();
          if (action != 'view' && action != 'edit') {
            props.setBusinessAreaId(data['data']['id']);
            // setRandomKey(new Date().getMilliseconds());
            nextStep();
          }
          getBuDetailByBuId()
          setIsEdit(false)
          //setSelectedTabValue(menuItems?.[1])
          setApiLoader(false);
          setIsUpdated(false);
          setIsDisabled(true);
        },
        data => {
          setApiLoader(false);
          setArrayState({ regionArray: [], businessUnitTypeArray: [], academicCareerArray: [], academicGroupArray: [], academicClassArray: [], studyCenterArray: [] });
          failureToast(data['message']);
        },
        obj,
        'put'
      );
    }
  };

  useEffect(() => {
    fetchData(masterServiceBaseUrl + '/companyCode/getAllActiveCompanyCode', setcompanyCode, 'companyCode');
    fetchData(masterServiceBaseUrl + '/region/getAllActiveRegion', setRegion, 'region');
    fetchData(
      masterServiceBaseUrl + '/businessUnitType/getAllActiveBusinessUnitType',
      setbusinessUnitType,
      'businessUnitType'
    );
    fetchData(masterServiceBaseUrl + '/groupCode/getAllActiveGroupCode', setgroupCode, 'groupCode');
    fetchData(
      masterServiceBaseUrl + '/academicInstitution/getAllActiveAcademicInstitution',
      setcampusInstitution,
      'academicInstitution'
    );
    fetchData(masterServiceBaseUrl + '/currency/getAllActiveCurrency', setCurrency, 'currency');
    // fetchData(masterServiceBaseUrl + '/academicCareer/getAllActiveAcademicCareer', setAcademicCareerData, 'academicCareer');
    fetchDetails(endpoint.state.getAllActive, setStateData, 'state', 'state');
     fetchData(endpoint.testType.getAllActive, setTestTypeIds, 'testType');
    // fetchData(endpoint.academic_group.getAllActive, setAcademicGroupData, 'academicGroup');
    // fetchData(endpoint.classes.getAllActive, setAcademicClassData, 'class');
  }, []);
  const dropdown = useMemo(() => {
    const d = {
      groupCode: group,
      companyCode,
      businessUnitType,
      campusInstitution,
      region,
      currency,
      stateCode: stateData.map((item) => ({ ...item, customId: item?.stateCode })),
      status: statusDropdown,
      franchiseType: franchiseTypeDropdown,
      groupCodeId: group,
      currencyId: currency,
      companyCodeId: companyCode,
      campusInstitutionId: campusInstitution,
      regionIds: region,
      testTypeIds
    }
    setDropdowns((prev) => ({ ...prev, ...d }));
    return d;
  }, [group, companyCode, businessUnitType, campusInstitution, region, currency, stateData, testTypeIds])


  // const onKeyPress = (e) => {
  //   if (
  //     !regex.alphaNumeric.test(
  //       String.fromCharCode(e.charCode)
  //     )
  //   ) {
  //     e.preventDefault();
  //     return;
  //   }
  // }
  const editHandler = () => {
    if (isEdit) {
      failureToast(saveOrDeleteMsg)
    }
    else {
      setIsEdit(true)
      setPrevData(value)
    }
  }
  const cancelHandler = () => {
    setValue(prevData)
    setIsEdit(false)
  }

  if (selectedTabValue?.id != 1) return null;
  return userPermissions ? (
    <>
      {apiloader ? (
        <div className="mx-auto text-center py-5 my-5" style={{ height: '50vh' }}>
          <Loader type="Rings" color="#00BFFF" height={70} width={70} timeout={10000} />
        </div>
      ) : (


        <Card className='ml-0'>
          <CardBody>
            <div className='d-flex justify-content-between align-items-center'>
              <div className='large-text color-grey-80'>Basic information</div>
              {action != 'view' ? action == 'new' ?
                <AButton
                  variant="primary_filled"
                  // className="w-full"
                  onClick={() => {
                    SaveButton()
                  }}
                  disabled={''}
                >
                  Save
                </AButton>
                :
                (!isEdit) ? <AButton
                  variant="outline"
                  // className="w-full"
                  onClick={() => {
                    editHandler()
                  }}
                  disabled={''}
                >
                  Edit
                </AButton>
                  : <div> <AButton
                    variant="primary_filled"
                    // className="w-full"
                    onClick={() => {
                      SaveButton()
                    }}
                    disabled={''}
                  >
                    Save changes
                  </AButton>
                    <AButton
                      variant="danger_filled"
                      // className="w-full"
                      onClick={() => {
                        cancelHandler()
                      }}
                      disabled={''}
                    >
                      Cancel
                    </AButton>
                  </div> : <></>}
            </div>
            <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>

            <DisplayViewData dataArray={basicDetail.mandatoryDetails ?? []}
              heading='Mandatory details'
              isEdit={isEdit || action == 'new'}
              action={action}
              rowFormHandler={(key, val) => {
                setValue({
                  ...value,
                  [key]: val
                })
              }}
              form={value}
              setForm={setValue}
              dropdown={dropdown}
            />

            {value?.businessUnitType.some(item => BU_TYPE_FRANCHISE_ACCESS.includes((item.label).toLowerCase())) && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
              <DisplayViewData
                dataArray={basicDetail.franchiseDetails ?? []}
                heading='Franchise details'
                isEdit={isEdit || action == 'new'}
                action={action}
                rowFormHandler={(key, val) => {
                  setValue({
                    ...value,
                    [key]: val
                  })
                }}
                form={value}
                setForm={setValue}
                dropdown={dropdown}
              /></>
            }
            <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <DisplayViewData
              dataArray={basicDetail.otherDetails ?? []}
              heading='Other details'
              isEdit={isEdit || action == 'new'}
              action={action}
              rowFormHandler={(key, val) => {
                setValue({
                  ...value,
                  [key]: val
                })
              }}
              form={value}
              setForm={setValue}
              dropdown={dropdown}
            />
            {(action === 'view' || action === 'edit') && value && getAuditDetails(value?.updatedBy, value?.updatedOn)}
          </CardBody>
        </Card>


      )}
      {/* <ConfirmationDialog title={"Unsaved changes"} subheading='Please save the changes before proceeding further' /> */}

    </>
  ) : (
    <PermisionDenied />
  );
};
export default BusinessUnit_2;
